export default "__VITE_ASSET__DH3l4Y54__"